<!---消费机管理--->
<template>
  <div>
    <list
      row-key="DeviceId"
      ref="list"
      unit="消费设备"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.list"
      form-label-width="100px"
    >
      <template slot="toolbar-right">
        <el-button size="small" class="filter-item" @click="onExport" type="primary" plain>导出</el-button>
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="设备编号">
          <el-input v-model="params.DeviceNo" placeholder="请输入设备编号" clearable />
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="params.DeviceName" placeholder="请输入设备名称" />
        </el-form-item>
        <el-form-item label="设备位置">
          <el-input v-model="params.Place" placeholder="请输入设备位置" />
        </el-form-item>
        <el-form-item label="设备IP">
          <el-input v-model="params.Ip" placeholder="请输入设备IP" />
        </el-form-item>
        <el-form-item label="启用状态">
          <el-select v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="连接状态">
          <el-select v-model="params.ConnectStatus" placeholder="请选择" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="异常" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="自动下发">
          <div style="width: 184px;">
            <el-checkbox v-model="params.SendStudent">学生</el-checkbox>
            <el-checkbox v-model="params.SendTeacher">教师</el-checkbox>
          </div>
        </el-form-item>-->
        <el-form-item label="数据下发状态">
          <el-select v-model="params.SendStatus" placeholder="请选择状态" clearable>
            <el-option label="待下发" :value="0"></el-option>
            <el-option label="下发中" :value="1"></el-option>
            <el-option label="下发完成" :value="2"></el-option>
            <el-option label="下发失败" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DeviceNo" label="设备编号" min-width="120px" />
        <el-table-column prop="DeviceName" label="设备名称" min-width="120px" />
        <el-table-column prop="Ip" label="设备IP" min-width="140px" />
        <el-table-column prop="Port" label="端口号" min-width="70px" />
        <el-table-column prop="UdpIp" label="UDP IP" min-width="140px" />
        <el-table-column prop="UdpPort" label="UDP端口" min-width="70px" />
         <el-table-column prop="Building" label="设备地点" min-width="120px" />
        <el-table-column prop="GroupName" label="设备分组" min-width="70px" />
        <el-table-column prop="Place" label="设备位置" min-width="120px" />
       
        <el-table-column prop="SingleLimit" label="单次消费限额" min-width="110px" />
        <el-table-column prop="Status" label="启用状态" min-width="80px">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.Status == 1">启用</el-tag>
            <el-tag type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="连接状态" min-width="80px">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.ConnectStatus == 1">正常</el-tag>
            <el-tag type="danger" v-else>异常</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="自动下发" min-width="100px">
          <template slot-scope="{row}">
            <el-tag type="primary" class="connect" v-if="row.SendStudent">学生</el-tag>
            <el-tag type="primary" class="connect" v-if="row.SendTeacher">教师</el-tag>
          </template>
        </el-table-column>-->
        <el-table-column prop="SendStatus" label="数据下发状态" min-width="100px">
          <template slot-scope="{row}">
            <!-- 待下发/下发中/下发完成/下发失败 -->
            <el-tag type="info" v-if="row.SendStatus == 0">待下发</el-tag>
            <el-tag type="primary" v-if="row.SendStatus == 1">下发中</el-tag>
            <el-tag type="success" v-if="row.SendStatus == 2">下发完成</el-tag>
            <el-tag type="danger" v-if="row.SendStatus == 3">下发失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="SendTime" label="最新下发数据时间" min-width="140px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/cp/device").default,
      params: {
        DeviceNo: "",
        DeviceName: "",
        Place: "",
        Ip: "",
        SendStatus: null,
        Status: null,
        ConnectStatus: null,
        DeviceType: 0,
        // SendStudent: null,
        // SendTeacher: null,
      },
    };
  },
  methods: {
    onExport() {
      this.api.export(this.$commonJs.obj.removeNullKey(this.params));
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .connect + .connect {
//   margin-left: 5px;
// }
</style>